import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matautocomplete',
	templateUrl:'./MatAutoCompletePage.html',
	styles: [],
	styleUrls:['./MatAutoCompletePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatAutoCompletePage
{
	mdContent_237 = `\`\`\`java
import com.jwebmp.plugins.angular.material.autocomplete.MatAutoComplete;
\`\`\``;
	mdContent_238 = `\`\`\`java
MatAutoComplete()
\`\`\``;
	mdContent_239 = `\`\`\`java
MatAutoComplete&lt;?&gt; ac = new MatAutoComplete&lt;&gt;();
ac.setPlaceholder("Search...");
ac.addOption("Angular");
ac.addOption("React");
ac.addOption("Vue");
ac.setAutoActiveFirstOption(true);
\`\`\``;
}
